import VueSlickCarousel from 'vue-slick-carousel'
import Vue from 'vue'

Vue.component('VueSlickCarousel', VueSlickCarousel)